import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { methodIcon, modifierTag } from './methodVisuals';
import styles from './PaymentMethodRow.module.css';

const DENIED_EDIT = 'Apenas proprietários e administradores podem editar métodos de pagamento';
const DENIED_DELETE = 'Apenas proprietários e administradores podem excluir métodos de pagamento';

/** Uma linha da lista: ícone, nome, selo do modificador e as ações em ícone. */
function PaymentMethodRow({ method, canManage, onEdit, onDelete }) {
  const Icon = methodIcon(method.Label);
  const tag = modifierTag(method.PriceModifier);

  return (
    <li className={styles.row}>
      <span className={styles.icon}><Icon /></span>

      <span className={styles.name}>{method.Label}</span>

      <span className={`${styles.tag} ${styles[tag.tone]}`}>{tag.text}</span>

      <span className={styles.actions}>
        <Tooltip title={canManage ? 'Editar método de pagamento' : DENIED_EDIT} arrow>
          <span>
            <IconButton
              size="small"
              className={styles.action}
              onClick={() => onEdit(method)}
              disabled={!canManage}
              aria-label={`Editar ${method.Label}`}
            >
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={canManage ? 'Excluir método de pagamento' : DENIED_DELETE} arrow>
          <span>
            <IconButton
              size="small"
              className={`${styles.action} ${styles.danger}`}
              onClick={() => onDelete(method)}
              disabled={!canManage}
              aria-label={`Excluir ${method.Label}`}
            >
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      </span>
    </li>
  );
}

export default PaymentMethodRow;
